import { httpRequest, endpoint } from "@cirrus/core/http"

export const logoutPOST = async () =>
  await httpRequest.post(endpoint.withRoot(`/api/v1/account/logoff`))
